import React, { Fragment } from 'react';
import styles from './styles.scss';
import Link from 'Components/Link';

export const InfoTextForGoogleCookies = (props) => {
  return (
    <Fragment>
      <h4 className={`h5 ${styles.marginBottomOneRow}`}>
        {props.type === 'statistik'
          ? 'Google Analytics (Leistungs- und Analyse-Cookies)'
          : 'Google Analytics Audiences (Marketing-Cookies)'}
      </h4>
      <h5 className={styles.h7_small_margin}>Beschreibung des Dienstes</h5>
      <p>
        Das ist ein Webanalyse-Dienst. Die Daten können in die Vereinigten Staaten übermittelt
        werden, wo das Datenschutzniveau möglicherweise nicht mit dem in der EU vergleichbar ist.
        Ein angemessenes Datenschutzniveau wird aber durch die Vereinbarung von sog.
        Standarddatenschutzklauseln gemäss Art. 46 Abs. 2 lit. c, Abs. 5 DSGVO sichergestellt.
        Ausserdem wurden ggf. zusätzliche Massnahmen umgesetzt.
      </p>
      <h5 className={styles.h7}>Verarbeitendes Unternehmen</h5>
      <p className={styles.marginBottomTwoRows}>
        <span lang="en">Google Ireland Limited</span>: Google Building Gordon House, 4 Barrow St,
        Dublin, D04 E5W5, Ireland
        <br />
        Den Datenschutzbeauftragten des verarbeitenden Unternehmens erreichen Sie über seine{' '}
        <Link
          to="https://support.google.com/policies/contact/general_privacy_form"
          isExternal
          label="E-Mail-Adresse"
        />
        .
      </p>
      {props.type === 'statistik' && (
        <Fragment>
          <ul className={styles.marginBottomTwoRows}>
            <li>
              <u>
                <strong>Kategorie</strong>
              </u>
              <ul>
                <li>Leistungs- und Analyse-Cookies</li>
              </ul>
            </li>
            <li>
              <p>
                <u>
                  <strong>Zweck der Daten</strong>
                </u>
              </p>
              <p>Diese Liste stellt die Zwecke der Erhebung und Verarbeitung der Daten dar.</p>
              <ul>
                <li>Analyse</li>
                <li>Optimierung</li>
              </ul>
            </li>
            <li>
              <p>
                <u>
                  <strong>Erhobene Daten</strong>
                </u>
              </p>
              <p>
                Diese Liste enthält alle (personenbezogenen) Daten, die durch oder bei der
                Verwendung dieses Dienstes erhoben werden.
              </p>
              <ul>
                <li>Browserinformation</li>
                <li>Datum und Uhrzeit des Besuchs</li>
                <li>Geräteinformationen</li>
                <li>Standortinformation</li>
                <li>IP-Adresse</li>
                <li>Besuchte Seiten</li>
                <li>Verweisende URL</li>
                <li>Nutzungsdaten</li>
                <li>Zustimmungsstatus</li>
              </ul>
            </li>
          </ul>
        </Fragment>
      )}
      {props.type === 'marketing' && (
        <Fragment>
          <ul>
            <li>
              <u>
                <strong>Kategorie</strong>
              </u>
              <ul>
                <li>Marketing-Cookies</li>
              </ul>
            </li>
            <li>
              <u>
                <strong>Zweck der Daten</strong>
              </u>
              <p>Diese Liste stellt die Zwecke der Erhebung und Verarbeitung der Daten dar.</p>
              <ul>
                <li>Analyse</li>
                <li>Werbung</li>
                <li>Marketing</li>
                <li>Remarketing</li>
                <li>Optimierung</li>
              </ul>
            </li>
            <li>
              <u>
                <strong>Erhobene Daten</strong>
              </u>
              <p>
                Diese Liste enthält alle (personenbezogenen) Daten, die durch oder bei der
                Verwendung dieses Dienstes erhoben werden.
              </p>
              <ul>
                <li>Browserinformation</li>
                <li>Datum und Uhrzeit des Besuchs</li>
                <li>Geräteinformationen</li>
                <li>Standortinformation</li>
                <li>Besuchte Seiten</li>
                <li>Verweisende URL</li>
                <li>Nutzungsdaten</li>
                <li>Zustimmungsstatus</li>
              </ul>
            </li>
          </ul>
        </Fragment>
      )}
      <h5 className={styles.h7}>Verwendete Technologien</h5>
      <p>
        Diese Liste stellt alle Technologien dar, die dieser Dienst zur Datenerhebung verwendet.
        Typische Technologien sind Cookies und Pixel, die im Browser platziert werden.
      </p>
      <ul>
        <li>Cookies</li>
        <li>Pixel</li>
        <li>
          <span lang="en">Tagging</span>
        </li>
        <li>Datenmodellierung</li>
      </ul>
      <h5 className={styles.h7}>Rechtsgrundlagen</h5>
      <p>Im Folgenden sind die erforderlichen Rechtsgrundlagen der Datenverarbeitung aufgeführt.</p>
      <ul>
        <li>Art. 6 Abs. 1 s. 1 lit a DSGVO</li>
      </ul>
      <h5 className={styles.h7}>Standort der Verarbeitung</h5>
      <p>
        Das ist der primäre Standort der Verarbeitung der erhobenen Daten. Wir informieren Sie,
        falls die Informationen in anderen Ländern verarbeitet werden.
      </p>
      <ul>
        <li>Europäische Union</li>
      </ul>
      <h5 className={styles.h7}>Dauer der Datenspeicherung</h5>
      <p>
        Die Aufbewahrungsfrist ist die Zeitspanne, in der die erhobenen Daten für die Zwecke der
        Verarbeitung gespeichert werden. Die Daten sind zu löschen, sobald sie für die angegebenen
        Verarbeitungszwecke nicht mehr benötigt werden.
      </p>
      <ul>
        <li>
          Die Daten sind zu löschen, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr
          benötigt werden.
        </li>
        <li>Maximale Dauer der Cookie-Speicherung: 2 Jahre</li>
      </ul>
      <h5 className={styles.h7}>Vertrieb in Drittländern</h5>
      <p>
        Der Dienst kann die erhobenen Daten in ein anderes Land übertragen. Bitte beachten, dass
        dieser Dienst die Daten ausserhalb der EU/EWR und in ein Land ohne die erforderlichen
        Datenschutzstandards übermitteln kann. Wenn die Daten in die Vereinigten Staaten übermittelt
        werden, besteht das Risiko, dass Ihre Daten von den US-Behörden ohne rechtliche Abhilfen zu
        Kontroll- und Überwachungszwecken verarbeitet werden. Im Folgenden finden Sie eine Liste der
        Länder, in die die Daten übermittelt werden. Das ist zu unterschiedlichen Zwecken, wie z. B.
        Speicherung oder Verarbeitung möglich.
      </p>
      <ul>
        <li>Vereinigte Staaten von Amerika</li>
      </ul>
      <h5 className={styles.h7}>Datenempfänger</h5>
      <p>Im Folgenden sind die Empfänger der erhobenen Daten aufgeführt.</p>
      <ul>
        <li>
          <span lang="en">Alphabet Inc.</span>, <span lang="en">Google LLC</span>,{' '}
          <span lang="en">Google Ireland Limited</span>
        </li>
      </ul>
      <p>
        <Link
          to="https://policies.google.com/privacy?hl=en"
          isExternal
          target="_blank"
          label="Klicken Sie hier, um die Datenschutzrichtlinie des Datenverarbeiters zu lesen."
        />
        <br />
        <Link
          to="https://tools.google.com/dlpage/gaoptout?hl=en"
          isExternal
          target="_blank"
          label="Klicken Sie hier, um diesen Verarbeiter für alle Domänen zu deaktivieren."
        />
      </p>
    </Fragment>
  );
};
